import { React, useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "../Transactions/Transactions.css";
import Button from "react-bootstrap/Button";

const TransactionLines = () => {
  const [loading, setLoading] = useState(true);
  const [transactionLines, setTransactionLines] = useState([]);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState({});
  const { transId } = useParams();

  const url = "api/processed-transactions";

  useEffect(() => {
    const getTransactionData = async () => {
      try {
        const response = await axios.get(url + `/${transId}`);
        setTransactionLines(response.data.transactionLines);
      } catch (e) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    };
    if (transId) {
      getTransactionData();
    }
  }, [transId]);

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Table hover bordered={false} responsive order>
        <thead>
          <tr>
            <th>Category Name</th>
            <th>Aircraft Registration Number</th>
            <th>Service Country</th>
            <th>Amount</th>
            <th>Errors</th>
          </tr>
        </thead>
        <tbody>
          {transactionLines && transactionLines.length > 0 ? (
            transactionLines.map((transaction) => (
              <>
                <tr key={transaction.transId}>
                 <td>{transaction.categoryName} </td>
                  <td>
                    {transaction.aircraftNumber
                      ? transaction.aircraftNumber
                      : "-"}
                  </td>
                  <td>
                    {transaction.serviceCountryName
                      ? transaction.serviceCountryName
                      : "-"}
                  </td>
                  <td>{transaction.amount}</td>
                  <td>{transaction.error ? transaction.error : "No Errors"}</td>
                </tr>
              </>
            ))
          ) : (
            <tr>
              <td colSpan="22">No Transactions Found</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Button onClick={() => window.close()} variant="outline-danger">
        Close
      </Button>
    </>
  );
};

export default TransactionLines;
